export var convertToTerminal = function (terminalDto) {
    return {
        id: terminalDto.id,
        uuid: terminalDto.uuid,
        marketplaceId: terminalDto.marketplace_id,
        terminalOrderId: terminalDto.terminal_order_id,
        businessProfileId: terminalDto.business_profile_id,
        addressId: terminalDto.address_id,
        name: terminalDto.name,
        serial: terminalDto.serial,
        model: terminalDto.model,
        poi: terminalDto.poi,
        supportRequired: terminalDto.support_required,
        replacementRequired: terminalDto.replacement_required,
        active: terminalDto.active,
        createdAt: terminalDto.created_at,
        updatedAt: terminalDto.updated_at,
        status: terminalDto.status,
    };
};
export var convertToTerminalToDto = function (uuid, terminals) {
    var terminalsDto = [];
    terminals
        .filter(function (terminal) { return terminal.qty > 0; })
        .map(function (terminal) {
        for (var index = 0; index < terminal.qty; index++) {
            var terminalDto = {
                terminal_model_id: terminal.id.toLowerCase(),
                marketplace_id: terminal.marketplaceId ? terminal.marketplaceId : 0,
                address_id: terminal.addressId ? terminal.addressId : 0,
                uuid: uuid(),
                name: uuid(),
                status: terminal.status,
                serial: terminal.serial ? terminal.serial : undefined,
                model: terminal.model ? terminal.model : "",
                poi: terminal.poi ? terminal.poi : "",
                active: true,
            };
            terminalsDto.push(terminalDto);
        }
        return "";
    });
    return terminalsDto;
};
export var convertToTerminalToModel = function (terminals) {
    var terminalsDto = [];
    if (terminals) {
        terminals.map(function (terminal) {
            var terminalDto = {
                id: terminal.terminal_model_id,
                name: terminal.terminal_model_id,
                qty: 1,
                price: 0,
                addressId: terminal.address_id,
                status: terminal.status,
                serial: terminal.serial,
                model: terminal.model,
                poi: terminal.poi,
                active: terminal.active,
                uuid: terminal.uuid,
            };
            terminalsDto.push(terminalDto);
            return "";
        });
    }
    return terminalsDto;
};
export var convertToPaymentOrder = function (payments) {
    var paymentsDto = [];
    if (payments) {
        payments.map(function (payment) {
            var paymentDto = {
                cardDigits: payment.card_digits,
                paymentMethodId: payment.payment_method_id,
            };
            paymentsDto.push(paymentDto);
            return "";
        });
    }
    return paymentsDto;
};
export var convertToTerminalOrder = function (terminalOrderDto) {
    return {
        id: terminalOrderDto.id,
        number: terminalOrderDto.number,
        uuid: terminalOrderDto.uuid,
        price: terminalOrderDto.price,
        status: terminalOrderDto.status,
        createAt: terminalOrderDto.created_at,
        adminInvoiceId: terminalOrderDto.admin_invoice_id ? terminalOrderDto.admin_invoice_id : undefined,
        contactEmail: "",
        deliveryAddress: terminalOrderDto.delivery_address,
        deliveryCity: terminalOrderDto.delivery_city,
        deliveryState: terminalOrderDto.delivery_state,
        deliveryZipcode: terminalOrderDto.delivery_zipcode,
        deliveryCountry: terminalOrderDto.delivery_country,
        deliveryName: terminalOrderDto.delivery_name,
        deliveryPhone: terminalOrderDto.delivery_phone,
        courier: terminalOrderDto.courier,
        trackingNumber: terminalOrderDto.tracking_number,
        notes: terminalOrderDto.notes,
        active: terminalOrderDto.active,
        terminals: convertToTerminalToModel(terminalOrderDto.terminals),
        adminPayments: convertToPaymentOrder(terminalOrderDto.admin_payments),
    };
};
export var convertToTerminalStatus = function (terminalId, dto) { return ({
    terminalId: terminalId,
    ready: dto.ready,
    message: dto.message,
}); };
